module.exports = __webpack_public_path__ + "static/media/dark-theme.9b12fd24.png";